import { useTheme } from "@mui/material";
import cn from "classnames";
import React, { useState, useEffect } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { calendarToday, swapVert1 } from "../assets";
import BuyNodeMessage from "../pages/Node/components/BuyNodeMessage";
import NoNodesMessage from "../pages/Node/components/NoNodesMessage";
import TableHead from "../pages/Node/components/TableHead";
import { referralHistories } from "../pages/Node/constants";

const ReferralHistoryTable = ({ referrdata, hasNodes }) => {
  const [nodesData, setNodesData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (referrdata && referrdata.length > 0) {
      setNodesData(referrdata);
      setIsLoading(false);
    }
  }, [referrdata]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedNodes = nodesData.sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  const theme = useTheme();
  const shortenAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 15)}...${address.substring(
      address.length - 4
    )}`;
  };

  const mobileShortenAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 5)}...${address.substring(
      address.length - 4
    )}`;
  };

  const sortByAmount = () => {
    requestSort("amount");
  };

  const sortByReferredAddress = () => {
    requestSort("referredAddress");
  };

  const sortByTXHash = () => {
    requestSort("txHash");
  };

  return (
    <div
      className={cn("overflow-y-hidden overflow-y-scroll hide-scrollbar ")}
      style={{ height: "calc(100% - 80px)" }}
    >
      {isLoading && (
        <div className="absolute inset-0 flex justify-center items-center bg-opacity-50 bg-transparent">
          <BiLoaderAlt
            className="animate-spin"
            size={50}
            color={theme.palette.mode === "light" ? "#000" : "#fff"}
          />
        </div>
      )}
      <table
        className={`w-full hide-scrollbar overflow-y-hidden ${
          isLoading ? "opacity-50" : ""
        }`}
      >
        <thead
          className={
            "sticky top-0 border-b border-lightGrayBlue bg-white z-10 dark:border-darkSlateBlue  dark:bg-darkCardBg"
          }
        >
          <tr className="grid grid-cols-9 items-center md:items-start w-full">
            <TableHead
              thName={"Amount"}
              sortData={sortByAmount}
              classes={"col-span-3"}
            />

            <TableHead
              thName={"Referred Address"}
              sortData={sortByReferredAddress}
              classes={"col-span-3"}
            />

            <TableHead
              thName={"TX hash"}
              sortData={sortByTXHash}
              classes={"col-span-3"}
            />
          </tr>
        </thead>
        <tbody>
          {sortedNodes.length > 0 ? (
            sortedNodes.map((row, index) => (
              <tr
                key={index}
                className="grid grid-cols-9 border-b border-lightGrayBlue dark:border-darkSlateBlue w-full"
              >
                <td className="col-span-3 pl-2 py-5 text-xs md:text-sm leading-6 text-black dark:text-white">
                  {`${row.amount} XBR`}
                </td>

                <td className="col-span-3 py-5 text-xs md:text-sm leading-6 text-black dark:text-white">
                  <span className="hidden md:block">
                    {shortenAddress(row.referredAddress)}
                  </span>
                  <span className="block md:hidden">
                    {mobileShortenAddress(row.referredAddress)}
                  </span>
                </td>
                <td className="col-span-3 py-5 text-xs md:text-sm leading-6 text-black dark:text-white">
                  <Link
                    to={`https://polygonscan.com/tx/${row.txHash}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="hidden md:block">
                      {shortenAddress(row.txHash)}
                    </span>
                    <span className="block md:hidden">
                      {mobileShortenAddress(row.txHash)}
                    </span>
                  </Link>
                </td>
              </tr>
            ))
          ) : hasNodes ? (
            <NoNodesMessage message={"referral history"} />
          ) : (
            <BuyNodeMessage messageText={"referrals"} />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReferralHistoryTable;
